import React from 'react';
import { useForm } from 'react-hook-form';
import { Engagement } from '../../types/engagement';

interface EngagementFormProps {
  engagement?: Partial<Engagement>;
  onSubmit: (data: Partial<Engagement>) => Promise<void>;
  onCancel: () => void;
}

export const EngagementForm: React.FC<EngagementFormProps> = ({
  engagement,
  onSubmit,
  onCancel,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<Partial<Engagement>>({
    defaultValues: {
      title: engagement?.title || '',
      description: engagement?.description || '',
      goal: engagement?.goal || '',
      deadline: engagement?.deadline ? new Date(engagement.deadline).toISOString().split('T')[0] : '',
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div>
        <label htmlFor="title" className="block text-sm font-medium text-gray-300 mb-1">
          Title <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="title"
          {...register('title', { required: 'Title is required' })}
          className="input w-full"
          placeholder="Enter engagement title"
        />
        {errors.title && (
          <p className="mt-1 text-sm text-red-500">{errors.title.message}</p>
        )}
      </div>

      <div>
        <label htmlFor="description" className="block text-sm font-medium text-gray-300 mb-1">
          Description
        </label>
        <textarea
          id="description"
          {...register('description')}
          className="input w-full h-24"
          placeholder="Enter engagement description"
        />
        {errors.description && (
          <p className="mt-1 text-sm text-red-500">{errors.description.message}</p>
        )}
      </div>

      <div>
        <label htmlFor="goal" className="block text-sm font-medium text-gray-300 mb-1">
          Goal
        </label>
        <textarea
          id="goal"
          {...register('goal')}
          className="input w-full h-24"
          placeholder="Enter engagement goal"
        />
        {errors.goal && (
          <p className="mt-1 text-sm text-red-500">{errors.goal.message}</p>
        )}
      </div>

      <div>
        <label htmlFor="deadline" className="block text-sm font-medium text-gray-300 mb-1">
          Deadline
        </label>
        <input
          type="date"
          id="deadline"
          {...register('deadline')}
          className="input w-full"
        />
        {errors.deadline && (
          <p className="mt-1 text-sm text-red-500">{errors.deadline.message}</p>
        )}
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="btn btn-secondary"
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Saving...' : engagement ? 'Update' : 'Create'}
        </button>
      </div>
    </form>
  );
};
